/**
 * <line-item-vin>
 *
 * Editable FIN/VIN field for Motortuning line items in the cart (page + drawer).
 * Persists the value as the "FIN/VIN" line item property via the AJAX cart API.
 *
 * Expected markup:
 *   <line-item-vin data-line-key="...">
 *     <div class="form-control"><input ... pattern="..."></div>
 *     <span class="line-item__vin-status" hidden></span>
 *   </line-item-vin>
 */
if (!customElements.get('line-item-vin')) {
  customElements.define(
    'line-item-vin',
    class LineItemVin extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.status = this.querySelector('.line-item__vin-status');

        if (!this.input) {
          return;
        }

        this._lastValue = this.input.value.trim().toUpperCase();
        this.input.addEventListener('change', this._onChange.bind(this));
      }

      get strings() {
        const themeStrings = (window.themeVariables && window.themeVariables.strings) || {};

        return {
          saved: themeStrings.vinSaved || 'Saved',
          invalid: themeStrings.vinInvalid || 'Please enter a valid 17-character VIN.',
          error: themeStrings.vinError || 'Could not save. Please try again.',
        };
      }

      async _onChange() {
        const value = this.input.value.trim().toUpperCase();
        this.input.value = value;

        if (value === this._lastValue) {
          return;
        }

        // Optional field: empty clears the property. Otherwise it must be a valid VIN.
        if (value !== '' && !/^[A-HJ-NPR-Z0-9]{17}$/.test(value)) {
          this._showStatus(this.strings.invalid, true);
          return;
        }

        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: this.dataset.lineKey,
              properties: { 'FIN/VIN': value },
            }),
          });

          if (!response.ok) {
            throw new Error(`Cart change failed with status ${response.status}`);
          }

          this._lastValue = value;
          this._showStatus(this.strings.saved, false);
        } catch (error) {
          console.error(error);
          this._showStatus(this.strings.error, true);
        }
      }

      _showStatus(message, isError) {
        if (!this.status) {
          return;
        }

        this.status.textContent = message;
        this.status.classList.toggle('text-error', Boolean(isError));
        this.status.hidden = false;
      }
    }
  );
}
